import React, { Component } from "react";
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

class CommonModal extends Component {
  constructor(props = {}) {
    super(props);
    this.state = {
      popupButtonLabel: props.buttonLabel || ''
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        popupButtonLabel: this.props.buttonLabel
      });
    }
  }

  setCommonModelButtonLabel = () => {
    return (this.state.popupButtonLabel ? this.state.popupButtonLabel : '');
  }
  render() {
    const {
      messageTitle,
      hasErrorMessage,
      buttonLabel,
      redirectCodeScreen,
      modalId = "commonModel",
    } = this.props;

    return (
      <dialog className="modal fade model-error" id={modalId} tabIndex="-1"  data-keyboard="false" data-backdrop="static" aria-labelledby={`${modalId}Label`} aria-hidden="true" >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
            </div>
            <div className="modal-body">
              <div className="logo">
                <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
              </div>
              {messageTitle && (<h5 className="modal-title  message-title " id="commonModellLabel">{messageTitle}</h5>)}
              <p className="text-center mt-4">{parse(hasErrorMessage)}</p>
            </div>
            <div className="modal-footer mb-4"> {buttonLabel && (
              <button type="button" className="btn btn-primary" onClick={redirectCodeScreen} >
                {this.setCommonModelButtonLabel()}
              </button>)}
            </div>
          </div>
        </div>
      </dialog>
    );
  }
}
CommonModal.propTypes = {
  buttonLabel: PropTypes.string,
  messageTitle: PropTypes.string,
  hasErrorMessage: PropTypes.string,
  redirectCodeScreen: PropTypes.func,
  modalId: PropTypes.string 
}
export default CommonModal;
